import { render, staticRenderFns } from "./PaymentsSchool.vue?vue&type=template&id=939ebb82"
import script from "./PaymentsSchool.vue?vue&type=script&lang=js"
export * from "./PaymentsSchool.vue?vue&type=script&lang=js"
import style0 from "./PaymentsSchool.vue?vue&type=style&index=0&id=939ebb82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports